<template>
  <div class="wapper">
    <el-page-header @back="goBack" :content="info.id == null ? '新增折算业绩与提成方案' : '修改折算业绩与提成方案'" class="header">
    </el-page-header>
    <div class="content-wapper">
      <el-form :model="info" :rules="rules" ref="ruleForm" label-width="170px" style="width:965px;">
        <el-form-item label="折算业绩与提成方案名称" prop="planName">
          <el-input placeholder="请输入折算业绩与提成方案名称" v-model="info.planName" class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="储值类型" prop="storedType">
          <el-radio v-model="info.storedType" v-for="item in storedTypes" :key="item.id" :label="item.id" @change="storedTypeChange">
            {{ item.name }}
          </el-radio>
        </el-form-item>
        <el-form-item label="适用应用规则是否参与折算" prop="flagPaltform">
          <el-radio-group v-model="info.flagPaltform" @change="flagPaltformChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="performanceRuleList-wapper" v-if="info.flagPaltform == 1">
            <div>
              <el-radio-group v-model="info.platformMatchType">
                <el-radio :label="1">满足以下任意条件之一</el-radio>
                <el-radio :label="2">同时满足以下所有条件</el-radio>
              </el-radio-group>
            </div>
            <div class="performanceRuleList-con">
              <div class="per-con-til">
                <p style="width: 98px;"></p>
                <p style="width: 70px;"> <span class="item-error">*</span>关系 </p>
                <p style="width: 200px;"> <span class="item-error">*</span>供应应用平台 </p>
                <p style="width: 215px;"> <span class="item-error">*</span>应用规则 </p>
                <p style="width: 44px;"></p>
              </div>
              <div>
                <div class="performanceRuleList-item" v-for="(item, index) in performanceRuleList" :key="index">
                  <span>条件：应用规则</span>
                  <div>
                    <el-select v-model="item.relationType" :disabled="true" style="width: 70px;">
                      <el-option :label="'包含'" :value="'1'"></el-option>
                      <el-option :label="'不包含'" :value="'0'"></el-option>
                    </el-select>
                  </div>
                  <el-select placeholder="请选择应用平台" v-model="item.platformCode" style="width: 200px;"
                    @change="platformCodeChange($event, index)" >
                    <el-option v-for="appitem in appPlatformList" :key="appitem.platformCode" :label="appitem.platformName"
                      :value="`${appitem.platformCode}`">
                    </el-option>
                  </el-select>

                  <div class="cards-template-item">
                    <el-select placeholder="请选择或者搜索名称" filterable v-model="item.appRuleCode" @change="appRuleCodeChange($event,item,index)" :remote="item.platformCode=='NEIGOU_SHOPING'?true: false" :remote-method="(query)=>remoteMethod(query, index)">
                      <el-option v-for="ruleitem in item.ruleList" :key="ruleitem.ruleId" :label="ruleitem.ruleName"
                        :value="`${ruleitem.ruleId}`">
                      </el-option>
                    </el-select>
                  </div>
                  <!-- <div v-if="item.isPointRuleOffline" class="cards-template-item" style="width: 215px;">
                    <el-select placeholder="请选择或者搜索名称" multiple collapse-tags v-model="item.ruleIdArr"
                      @change="changeSelect($event,index)">
                      <el-checkbox v-model="checked" @change='selectAll($event,index)' style="margin-left: 19px;">全选</el-checkbox>
                      <el-option v-for="item in ruleList" :key="item.ruleId" :label="item.ruleName"
                        :value="item.ruleId">
                      </el-option>
                    </el-select>
                  </div> -->
                  <div class="performanceRuleList-item-btn">
                    <el-button type="text" @click="removePerformanceRule(index)" v-show="index!=0">删除</el-button>
                  </div>
                </div>
                <el-button type="text" style="width: 100%;" size="small" @click="addPerformanceRule">增加1个条件</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="适用应用规则折算业绩系数" prop="performanceRuleFactor" v-if="info.flagPaltform == 1">
          <el-input v-model="info.performanceRuleFactor" class="input-width" placeholder="请输入适用应用规则折算业绩系数" @change="performanceRuleFactorChange">
            <template slot="append">%</template>
          </el-input>
          <div class="notes">注：需输入大于等于0且小于等于100的数值，并设置上方的条件，当销售下单满足上方条件时将按照你填入的系数折算业绩，不满足时不折算</div>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <span class="item-error">*</span>
            <span>有效期折算业绩系数</span>
          </template>
          <div class="notes" style="height: 40px; display: flex;align-items: center;">
            注：设置有效期区间和每个区间对应的折算业绩系数，月数为自然数，系数大于等于0且小于等于100，销售下单时将按照该区间折算业绩
          </div>
        </el-form-item>
        <div class="table-wapper coefficient-table">
          <table class="table-title coefficient-table-inner">
            <colgroup>
              <col class="c-type">
              <col class="c-term">
              <col class="c-rate">
              <col class="c-op">
            </colgroup>
            <thead>
              <tr>
                <td colspan="4">
                  有效期折算业绩系数
                  <a href="javascript:void(0);" @click="addValidityCoefficient">添加区间</a>
                </td>
              </tr>
              <tr style="text-align:left;font-weight: normal;">
                <td>类型</td>
                <td>有效期</td>
                <td>有效期折算业绩系数</td>
                <td>操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in conversionValidityList" :key="idx">
                <td>有效期区间</td>
                <td :class="fieldErrorClass(idx, 'months')">
                  <input type="text" v-model.number="row.minMonth"> 个月(含) ~
                  <input type="text" v-model.number="row.maxMonth"> 个月(不含)
                </td>
                <td :class="fieldErrorClass(idx, 'coefficient')">
                  <input type="text" v-model.number="row.coefficient"> %
                </td>
                <td>
                  <a href="javascript:void(0);" class="remove" @click="removeValidityCoefficient(idx)">删除</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-form-item label="经理审批线" prop="managerLine">
          <el-input v-model="info.managerLine" class="input-width">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 &lt; 该界线值时，订单需经理审批。</div>
        </el-form-item>
        <el-form-item label="总监审批线" prop="directorLine">
          <el-input class="input-width" v-model="info.directorLine">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 &lt; 该界线值时，订单需总监审批。</div>
        </el-form-item>
        <el-form-item label="折算业绩线" prop="conversionLine">
          <el-input class="input-width" v-model="info.conversionLine">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 < 该界线值时，按照预先配置的审批流，由设置好的审批人审批。</div>
        </el-form-item>
        <el-form-item label="禁止销售线" prop="saleLine">
          <el-input class="input-width" v-model="info.saleLine">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 &lt; 该界线值时，系统提醒销售需要走特殊审批流程。</div>
        </el-form-item>
        <el-form-item label="特殊提成计算基准值" prop="royaltySpecialValue">
          <el-input class="input-width" placeholder="请输入特殊提成计算基准值" v-model="info.royaltySpecialValue">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <!-- 提成方案 -->
      <div class="notes" style="padding-left:150px;">注：提成方案至少需要一个销售金额大于0的提成方案，否则将可能无法创建订单。</div>
      <div class="table-wapper">
        <table class="table-title">
          <colgroup>
            <col width="80">
            <col width="200">
            <col width="80">
            <col width="80">
            <col width="80">
            <col width="100">
            <col width="50">
          </colgroup>
          <tr>
            <td colspan="7">
              售价折算业绩及提成方案表
              <a href="javascript:void(0);" @click="addPlanTable">新增方案</a>
            </td>
          </tr>
          <tr style="text-align:left;font-weight: normal;">
            <td>类型</td>
            <td>实际售价</td>
            <td>销售提成</td>
            <td>经理提成</td>
            <td>总监提成</td>
            <td>售价折算业绩系数</td>
            <td>操作</td>
          </tr>
        </table>
        <table v-for="(plan, planIndex) in royaltyPlans" :key="planIndex" class="data-table">
          <colgroup>
            <col width="80">
            <col width="200">
            <col width="80">
            <col width="80">
            <col width="80">
            <col width="100">
            <col width="50">
          </colgroup>
          <tr>
            <td colspan="7">
              <span ref="plan-item-salesAmount">
                销售总金额大于
                <input :disabled="planIndex == 0" type="text" style="width:112px;" v-model.number="plan.salesAmount">
                元
              </span>
              <a v-if="planIndex > 0" href="javascript:void(0);" @click="removePlanTable(planIndex)" style="right:80px;"
                class="remove">删除方案</a>
              <a href="javascript:void(0);" @click="addPlan(planIndex)">添加区间</a>
            </td>
          </tr>
          <tr v-for="(item, index) in plan.list" :key="index">
            <td>{{ item.isSection == 1 ? "区间售价" : "标准售价" }}</td>
            <!-- 标准售价 -->
            <td v-if="item.isSection == 2" :ref="refName(planIndex, 'lowestPrice')">
              <input type="text" v-model.number="item.lowestPrice" @change="lowestPriceChange(item)">元
            </td>
            <!-- 区间售价 -->
            <td v-else :ref="refName(planIndex, 'lowestPrice')">
              <input type="text" v-model.number="item.lowestPrice">元(含) ~ <input type="text"
                v-model.number="item.maximumPrice">元(不含)
            </td>
            <td :ref="refName(planIndex, 'saleRoyalty')">
              <input type="text" v-model.number="item.saleRoyalty">%
            </td>
            <td :ref="refName(planIndex, 'managerRoyalty')">
              <input type="text" v-model.number="item.managerRoyalty">%
            </td>
            <td :ref="refName(planIndex, 'directorRoyalty')">
              <input type="text" v-model.number="item.directorRoyalty">%
            </td>
            <td :ref="refName(planIndex, 'saleConversionFactor')">
              <input type="text" v-model.number="item.saleConversionFactor">%
            </td>
            <td>
              <a v-if="index < (plan.list.length - 2)" href="javascript:void(0);" @click="removePlan(planIndex, index)"
                class="remove">删除</a>
            </td>
          </tr>
        </table>
      </div>
      <!-- <div class="button-wapper">
        <el-button size="small" type="primary" @click="submit">下一步</el-button>
      </div> -->
      <AddRoyaltyPlanSecond ref="addRoyaltyPlanSecond" @submit="submitDialog" @closeDialog="closeDialog" />
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>{{ id?'提交成功后将按当前的设置更新方案，是否确认提交？':'是否确认提交？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import _constant from '@/utils/constant'
import _royaltyPlan from '@/service/royalty-plan-service'
import schema from 'async-validator'
import AddRoyaltyPlanSecond from './add-royalty-plan-second.vue'
export default {
  components:{
    AddRoyaltyPlanSecond
  },
  data() {
    return {
      dialogVisible: false,
      id: this.$route.query.id,
      type: this.$route.query.type,
      storedTypes: null,
      info: {
        id: this.$route.query.id,
        planName: null,
        storedType: 1,
        conversionValidityList: null,
        managerLine: null,
        directorLine: null,
        saleLine: null,
        planSales: null,
        royaltySpecialValue: null,
        flagPaltform: 0, //适用应用规则是否参与折算 次卡默认是 点卡默认否
        platformMatchType: 1, //1：满足任意条件，2：满足所有条件
        performanceRuleFactor: null,
        conversionLine: null,
      },
      performanceRuleList: [],
      appPlatformList: [],
      conversionValidityList: [],
      ruleList: [],
      checked:false,
      isPointRuleOffline: false,
      validityCoefficientErrors: {},
      royaltyPlans: [
        {
          salesAmount: 0,
          list: [
            {
              // 1=区间售价，2=标准售价
              isSection: 1,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            },
            {
              // 1=区间售价，2=标准售价
              isSection: 2,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            }
          ]
        }
      ],
      salesAmountRule: {
        salesAmount: {
          pattern: /^\d+(\.\d{1,2})?$/,
          required: true,
        }
      },
      royaltyPlanRule: {
        lowestPrice: {
          pattern: /^\d+(\.\d{1,2})?$/,
          required: true,
        },
        maximumPrice: {
          pattern: /^\d+(\.\d{1,2})?$/,
          required: true,
        },
        saleRoyalty: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
        managerRoyalty: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
        directorRoyalty: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
        saleConversionFactor: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
      },
      rules: {
        planName: [
          { required: true, message: '请输入折算业绩与提成方案名称', trigger: 'blur' },
          { max: 32, message: '提成方案名称最大32个字符', trigger: 'blur' },
        ],
        storedType: [
          { required: true, message: '请选择储值类型', trigger: 'change' },
        ],
        managerLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '经理审批线必须为数字最多保留两位小数', trigger: 'blur' }
        ],
        directorLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '总监审批线必须为数字最多保留两位小数', trigger: 'blur' }
        ],
        conversionLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '折算业绩线必须为数字最多保留两位小数', trigger: 'blur' }
        ],
        saleLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '禁止销售线必须为数字最多保留两位小数', trigger: 'blur' }
        ],
        royaltySpecialValue: [
          { required: true, message: '请输入特殊提成计算基准值', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '特殊提成计算基准值必须为数字', trigger: 'blur' }
        ],
        flagPaltform: [
          { required: true, message: '请选择适用应用规则是否参与折算', trigger: 'blur' },
          { required: true, message: '请选择适用应用规则是否参与折算', trigger: 'change' },
        ],
        performanceRuleFactor: [
          { required: true, message: '请输入适用应用规则折算业绩系数', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '适用应用规则折算业绩系数必须为数字最多保留两位小数', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {

  },
  mounted() {
    this.getAppPlatformList()
    this.addPerformanceRule()
    this.storedTypes = _constant.storedTypes
    // 是否编辑
    if (this.info.id != null && this.type == 'edit') {
      let _loading = this.$loading({ fullscreen: true })
      _royaltyPlan.royaltyPlanDetalis(this.info.id, response => {
        _loading.close()
        this.info = response
        this.royaltyPlans = this.info.planSales
        if(this.info.performanceRuleList){
          this.performanceRuleList=this.info.performanceRuleList
          this.getAppRuleList()
        }
        if (this.info.conversionValidityList) {
          this.conversionValidityList = this.info.conversionValidityList.map(item => ({
            minMonth: item.minMonth,
            maxMonth: item.maxMonth,
            coefficient: item.coefficient
          }))
        } else {
          this.addValidityCoefficient()
        }
      })
    }
  },
  methods: {
    refName(planIndex, name) {
      return 'plan-item' + planIndex + '-' + name
    },
    lowestPriceChange(item) {
      item.maximumPrice = item.lowestPrice
    },
    goBack() {
      this.$router.back()
    },
    // 添加方案
    addPlan(index) {
      this.royaltyPlans[index].list.unshift(
        {
          // 1=区间售价，2=标准售价
          isSection: 1,
          lowestPrice: null,
          maximumPrice: null,
          saleRoyalty: null,
          managerRoyalty: null,
          directorRoyalty: null,
          saleConversionFactor: null,
        }
      )
    },
    addPlanTable() {
      this.royaltyPlans.push(
        {
          salesAmount: null,
          list: [
            {
              // 1=区间售价，2=标准售价
              isSection: 2,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            },
            {
              // 1=区间售价，2=标准售价
              isSection: 1,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            }
          ]
        }
      )
    },
    // 删除方案
    removePlanTable(planIndex) {
      this.royaltyPlans.splice(planIndex, 1)
    },
    // 删除规则
    removePlan(planIndex, index) {
      this.royaltyPlans[planIndex].list.splice(index, 1)
    },
    closeDialog(){
      this.dialogVisible = false
    },
    // 提交
    submit() {
      if(!this.performanceRuleValidate()){
        this.dialogVisible = false
        return
      } else{
        this.info.performanceRuleList=this.performanceRuleList
      }
      var isPlans = true
      var isSalesAmount = true
      var isValidityCoefficient = true
      this.validityCoefficientErrors = {}
      this.$refs['plan-item-salesAmount'].forEach(el => {
        el.className = ''
      })
      var saValidator = new schema(this.salesAmountRule)
      var validator = new schema(this.royaltyPlanRule)
      this.royaltyPlans.forEach((plan, planIndex) => {
        saValidator.validate(plan, (errors) => {
          if (errors != null) {
            isPlans = false
            errors.forEach(() => {
              this.$refs['plan-item-salesAmount'][planIndex].className = 'item-error'
            })
          }
        })
        // 清除原有样式
        this.$refs[this.refName(planIndex, 'lowestPrice')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'saleRoyalty')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'managerRoyalty')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'directorRoyalty')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'saleConversionFactor')].forEach(el => {
          el.className = ''
        })
        plan.list.forEach((item, index) => {
          validator.validate(item, (errors) => {
            if (errors != null) {
              isSalesAmount = false
              errors.forEach(error => {
                if (error.field == 'maximumPrice') {
                  this.$refs[this.refName(planIndex, 'lowestPrice')][index].className = 'item-error'
                } else {
                  this.$refs[this.refName(planIndex, error.field)][index].className = 'item-error'
                }
              })
            }
          })
        })
      })

      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$notify({ message: '有必填项未填写，请检查后再提交', type: 'warning' })
          this.dialogVisible = false
          return false
        }
        isValidityCoefficient = this.validateValidityCoefficientList()
        if(!isValidityCoefficient){
          this.dialogVisible = false
          return false
        }
        if ( !isSalesAmount  || !isPlans) {
          this.$notify({ message: '售价折算业绩及提成方案表存在未填写项，请检查后再提交', type: 'warning' })
          this.dialogVisible = false
          return false
        }
        this.info.conversionValidityList = this.normalizeValidityCoefficientList()
        this.info.planSales = this.royaltyPlans
        if(this.info.flagPaltform==0){
          this.info.performanceRuleList = []
        }
        // 提交请求
        let _loading = this.$loading({ fullscreen: true })
        if (this.type == 'edit') {
          _royaltyPlan.planFirstEdit(this.info, (res) => {
            _loading.close()
            // 跳转第二步
            this.$refs.addRoyaltyPlanSecond.submit(res)
          }, err => {
            _loading.close()
            this.dialogVisible = false
            this.$notify({
              message: err,
              type: 'warning'
            })
          })
        } else {
          _royaltyPlan.planFirstAdd(this.info, response => {
            _loading.close()
            // 跳转第二步
            this.$refs.addRoyaltyPlanSecond.submit(response)
          }, err => {
            _loading.close()
            this.dialogVisible = false
            this.$notify({
              message: err,
              type: 'warning'
            })
          })
        }
      })
    },
    addValidityCoefficient() {
      this.conversionValidityList.unshift({ minMonth: null, maxMonth: null, coefficient: null })
    },
    removeValidityCoefficient(idx) {
      this.conversionValidityList.splice(idx, 1)
    },
    fieldErrorClass(idx, field) {
      return this.validityCoefficientErrors[`${idx}-${field}`] ? 'item-error' : ''
    },
    normalizeValidityCoefficientList() {
      return (this.conversionValidityList || [])
        .map(item => ({
          minMonth: item.minMonth,
          maxMonth: item.maxMonth,
          coefficient: item.coefficient
        }))
        .sort((a, b) => (a.minMonth ?? 0) - (b.minMonth ?? 0))
    },
    validateValidityCoefficientList() {
      const list = this.normalizeValidityCoefficientList()
      if (!Array.isArray(list) || list.length < 1) {
        this.$notify({ message: '请至少添加一个有效期折算业绩系数区间', type: 'warning' })
        return false
      }

      const setErr = (idx, field) => {
        this.$set(this.validityCoefficientErrors, `${idx}-${field}`, true)
      }

      let ok = true
      const usedRanges = []
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        const start = row.minMonth
        const end = row.maxMonth
        const coeff = row.coefficient

        const isNatural = (n) => Number.isInteger(n) && n >= 0
        if (!isNatural(start) || !isNatural(end) || start >= end) {
          setErr(i, 'months')
          ok = false
        }
        if (!(typeof coeff === 'number') || Number.isNaN(coeff) || coeff < 0 || coeff > 100) {
          setErr(i, 'coefficient')
          ok = false
        }
        if (ok) {
          usedRanges.push({ start, end, idx: i })
        }
      }

      usedRanges.sort((a, b) => a.start - b.start)
      for (let i = 1; i < usedRanges.length; i++) {
        const prev = usedRanges[i - 1]
        const curr = usedRanges[i]
        if (curr.start < prev.end) {
          setErr(prev.idx, 'months')
          setErr(curr.idx, 'months')
          ok = false
        }
      }

      if (!ok) {
        this.$notify({ message: '有效期折算业绩系数配置有误，请检查红色标记项（区间需为自然月且不重叠，系数为0~100）', type: 'warning' })
      }
      return ok
    },
    platformCodeChange(e, index) {
      this.appPlatformList.forEach(item=>{
        if(item.platformCode==e){
          this.performanceRuleList[index].platformName = item.platformName
        }
      })
      if (e != 'NEIGOU_SHOPING') {
        this.getRuleListByPlatform('',index);
      }
      this.performanceRuleList[index].ruleList = [];
      this.performanceRuleList[index].appRuleCode = '';
    },
    getRuleListByPlatform(query,index) {
      if (this.performanceRuleList[index].platformCode != null) {
        this.appPlatformList.forEach(item => {
          if (item.platformCode == this.performanceRuleList[index].platformCode) {
            var code_url = '';
            if (item.ruleCodeUrl.includes('getBrandList')) {
              code_url = item.ruleCodeUrl;
            } else {
              code_url = item.ruleCodeUrl + '&name=' + query;
            }
            _royaltyPlan.getRuleListByPlatform(code_url, response => {
              this.$set(this.performanceRuleList[index], 'ruleList', response)
              this.$forceUpdate()
            })
            return
          }
        })

      } else {
        this.ruleList = null
      }
    },
    // 查询应用平台
    getAppPlatformList() {
      _royaltyPlan.getAppPlatformList(res => {
        this.appPlatformList = res
      })
    },
    remoteMethod() {

    },
    // 规则全选
    selectAll(e,index){
      this.performanceRuleList[index].ruleIdArr=[]
      if(this.checked){
        this.ruleList.forEach(item=>{
          this.performanceRuleList[index].ruleIdArr.push(item.ruleId)
        })
      } else {
        this.performanceRuleList[index].ruleIdArr=[]
      }
      this.performanceRuleList[index].appRuleCode = this.ruleIdArr
    },
    // 规则反选
    changeSelect(val,index){
      this.performanceRuleList[index].appRuleCode = val
      if(val.length==this.ruleList.length){
        this.checked=true
      } else {
        this.checked=false
      }
    },
    removePerformanceRule(index){
      this.performanceRuleList.splice(index,1)
    },
    addPerformanceRule(){
      this.performanceRuleList.push({
        platformCode: null,
        appRuleCode: null,
        appRuleName: null,
        platformName: null,
        relationType: '1',
        ruleList: [],
      })
    },
    appRuleCodeChange(e,item,index){
      item.ruleList.forEach(row=>{
        if(row.ruleId==e){
          this.performanceRuleList[index].appRuleName = row.ruleName
        }
      })
    },
    flagPaltformChange(){
      // this.$set(this.info, 'platformMatchType', 1)
      // this.performanceRuleList=[
      //   {
      //     relationType: '1',
      //     platformCode: '',
      //     appRuleCode: '',
      //     ruleList: [],
      //   }
      // ]
    },
    performanceRuleFactorChange(){
      if(this.info.performanceRuleFactor > 100){
        this.$set(this.info, 'performanceRuleFactor', 100)
      }
      if(this.info.performanceRuleFactor < 0){
        this.$set(this.info, 'performanceRuleFactor', 0)
      }
    },
    storedTypeChange(){
      // this.$set(this.info, 'performanceRuleFactor', null)
      let { storedType } = this.info
      if (storedType == 1) {
        this.$set(this.info, 'flagPaltform', 0)
      }
      if (storedType == 2) {
        this.$set(this.info, 'flagPaltform', 1)
      }
    },
    performanceRuleValidate() {
      if(this.info.flagPaltform == 1){
        if(this.performanceRuleList.length == 0){
          this.$notify({ message: '请至少添加一个条件', type: 'warning' })
          return false
        }
        if(!this.performanceRuleList.every(item => item.platformCode && item.appRuleCode)){
          this.$notify({ message: '请选择应用平台和应用规则', type: 'warning' })
          return false
        }
        //应用规则不可重复
        if(this.performanceRuleList.some(item => item.appRuleCode && this.performanceRuleList.filter(i => i.appRuleCode == item.appRuleCode).length > 1)){
          this.$notify({ message: '应用规则不可重复', type: 'warning' })
          return false
        }
        return true
      }
      return true
    },
    // 获取应用规则
    getAppRuleList(){
      this.performanceRuleList.forEach((item,index)=>{
        if(item.platformCode){
          this.getRuleListByPlatform('',index)
        }
      })
    },
    remoteMethod(query,index){
      if (query !== '') {
        this.loading = true;
        this.getRuleListByPlatform(query,index);
      } else {
        this.performanceRuleList[index].ruleList = null
      }
    },
    submitDialog(){
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}

.header {
  margin-bottom: 15px;
}

.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 15px;
  background: #fff;
}

.cards-template-wapper {
  background: #d6dbe5;
  padding: 15px;
  border-radius: 3px;
}

.cards-template-item {
  margin-right: 15px;
  display: inline-block;
}

.tips {
  font-size: 12px;
}

.selected-wapper {
  font-size: 12px;
  border-top: 1px dashed #909399;
  margin-top: 15px;
  padding-top: 15px;
}

.selected-title {
  display: inline-block;
  width: 80px;
  text-align: left;
  color: #909399;
}

.selected-name {
  display: inline-block;
  margin-right: 20px;
}

.button-wapper {
  margin-left: 150px;
}

.button-wapper .el-button {
  width: 814px;
}

.upload-wapper {
  position: relative;
  display: inline-block;
  margin-right: 15px;
}

.upload-wapper input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 210px;
  height: 100px;
  opacity: 0;
}

.image-slot span {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  font-size: 12px;
  border: 1px dashed #909399;
  border-radius: 5px;
  color: #909399;
}

.notes {
  font-size: 12px;
  color: #F56C6C;
  line-height: 17px;
}

.table-wapper {
  width: 825px;
  font-size: 12px;
  margin-left: 150px;
  margin-bottom: 30px;
  border: 1px double #909399;
  border-top: none;
  border-width: 3px;
}

.coefficient-table {
  margin-left: 170px;
}

.coefficient-table .coefficient-table-inner {
  table-layout: fixed;
}

.coefficient-table col.c-type {
  width: 160px;
}

.coefficient-table col.c-term {
  width: 280px;
}

.coefficient-table col.c-rate {
  width: 275px;
}

.coefficient-table col.c-op {
  width: 100px;
}

.table-wapper .el-radio {
  display: block;
  width: 100%;
}

.table-wapper .el-input {
  width: 50px;
}

.table-wapper .table-title td {
  padding: 6px;
  border-top: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
  position: relative;
  white-space: nowrap;
}

.table-wapper input {
  color: #383e43;
  width: 50px;
  text-align: center;
}

.table-wapper .table-title td:last-child {
  border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child {
  border-top: 1px double #909399;
  border-width: 3px;
}

.table-wapper table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.table-title {
  font-weight: bold;
  background: #f9f9f9;
  text-align: center;
}

.data-table {
  border-top: none;
  position: relative;
}

.data-table td {
  padding: 6px;
  border-top: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
  border-bottom: 1px solid #d6dbe5;
}

.data-table td:last-child {
  border-right: 1px solid #d6dbe5;
}

.td-merge {
  border-right: none !important;
}

.table-wapper .opertion {
  background: #f9f9f9;
}

.table-wapper .el-input-number--small {
  width: 100px;
}

.table-wapper a {
  color: #409eff;
}

.table-wapper .table-title a {
  position: absolute;
  right: 10px;
}

.data-table a {
  /* position: static; */
  position: absolute;
  right: 10px;
}

.table-wapper .remove {
  color: #F56C6C;
}

.opertion-title {
  font-weight: bold;
}

input {
  border-bottom: 1px solid #DCDFE6;
}

.item-error {
  color: #F56C6C;
}

.item-error input {
  border-color: #F56C6C;
}

.input-width {
  width: 250px;
}

.performanceRuleList-wapper {
  margin-bottom: 10px;
  border: 1px solid #d6dbe5;
  border-radius: 5px;
  padding: 10px;
}
.performanceRuleList-con{
  border-top: 1px solid #d6dbe5;
  padding-top: 10px;
}
.performanceRuleList-con .per-con-til {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 10px;
}
.performanceRuleList-con .per-con-til p {
  text-align: center;
}
.performanceRuleList-item {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 22px;
}
.performanceRuleList-item-btn {
  width: 44px;
  text-align: center;
}
</style>